import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TravelFormPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to home page
    navigate('/');
  }, [navigate]);

  return null;
};

export default TravelFormPage;
